import React from 'react'
import Header from './Header'
import Navigation from './Navigation'

export default class Page extends React.Component {
  headerClass(appState) {
    switch (appState.inProgress) {
      case '': return 'page-init'
      case true: return 'content-loading'
      case false: return 'content-loaded'
      default: return 'error'
    }
  }

  render() {
    const ContentWrapper = () => {
      // Adds a prop to this.props.children
      return (
        React.cloneElement(this.props.page, {
            changePage: this.props.changePage,
            content: this.props.content,
            imagesLoaded: this.props.imagesLoaded,
            imageLoad: this.props.imageLoad
          }
        )
      )
    }
    if (this.props.content.contentLoaded) {
      return (
        <main className={this.headerClass(this.props.content)}>
          <Navigation content={this.props.content} selectedPage={this.props.selectedPage} />
          <Header selectedPage={this.props.selectedPage} content={this.props.content} />
          <ContentWrapper />
        </main>
      )
    } else {
      return null
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/global/Page.js